var map = {
	"./address-icon.png": 46496,
	"./courses-icon.png": 33366,
	"./email-icon.png": 33584,
	"./instructor-01.jpg": 40275,
	"./instructor-02.jpg": 46116,
	"./instructor-03.jpg": 24161,
	"./instructor-04.jpg": 98674,
	"./instructor-bg-banner--.png": 4870,
	"./instructor-bg-banner.png": 6404,
	"./instructor-course-icon.svg": 59639,
	"./instructor-reviews-icon.svg": 27287,
	"./instructor-students-icon.svg": 34254,
	"./instructor-table-01.jpg": 5926,
	"./instructor-table-02.jpg": 63697,
	"./instructor-table-03.jpg": 62791,
	"./instructor-table-04.jpg": 87135,
	"./instructor-table-05.jpg": 67138,
	"./phone-icon.png": 35744,
	"./profile-avatar.jpg": 24777,
	"./review-icon.png": 4114,
	"./ttl-stud-icon.png": 89387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48828;